function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license
 * Copyright (c) 2022 - 2023 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */
import { SlotController } from './slot-controller.js';
/**
 * A controller that observes slotted element mutations, especially ID attribute
 * and the text content, and fires an event to notify host element about those.
 */

export var SlotChildObserveController = /*#__PURE__*/function (_SlotController) {
  _inherits(SlotChildObserveController, _SlotController);

  var _super = _createSuper(SlotChildObserveController);

  function SlotChildObserveController(host, slot, tagName) {
    var config = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    _classCallCheck(this, SlotChildObserveController);

    return _super.call(this, host, slot, tagName, _objectSpread(_objectSpread({}, config), {}, {
      useUniqueId: true
    }));
  }
  /**
   * Override to initialize the newly added custom node.
   *
   * @param {Node} node
   * @protected
   * @override
   */


  _createClass(SlotChildObserveController, [{
    key: "initCustomNode",
    value: function initCustomNode(node) {
      this.__updateNodeId(node);

      this.__notifyChange(node);
    }
    /**
     * Override to notify the controller host about removal of
     * the custom node, and to apply the default one if needed.
     *
     * @param {Node} _node
     * @protected
     * @override
     */

  }, {
    key: "teardownNode",
    value: function teardownNode(_node) {
      var node = this.getSlotChild(); // Custom node is added to the slot

      if (node && node !== this.defaultNode) {
        this.__notifyChange(node);
      } else {
        this.restoreDefaultNode();
        this.updateDefaultNode(this.node);
      }
    }
    /**
     * Override method inherited from `SlotMixin`
     * to set ID attribute on the default node.
     *
     * @return {Node}
     * @protected
     * @override
     */

  }, {
    key: "attachDefaultNode",
    value: function attachDefaultNode() {
      var node = _get(_getPrototypeOf(SlotChildObserveController.prototype), "attachDefaultNode", this).call(this);

      if (node) {
        this.__updateNodeId(node);
      }

      return node;
    }
    /**
     * Override to restore default node when a custom one is removed.
     *
     * @protected
     */

  }, {
    key: "restoreDefaultNode",
    value: function restoreDefaultNode() {// To be implemented
    }
    /**
     * Override to update default node text on property change.
     *
     * @param {Node} node
     * @protected
     */

  }, {
    key: "updateDefaultNode",
    value: function updateDefaultNode(node) {
      this.__notifyChange(node);
    }
    /**
     * Setup the mutation observer on the node to update ID and notify host.
     * Node doesn't get observed automatically until this method is called.
     *
     * @param {Node} node
     * @protected
     */

  }, {
    key: "observeNode",
    value: function observeNode(node) {
      var _this = this;

      // Stop observing the previous node, if any.
      if (this.__nodeObserver) {
        this.__nodeObserver.disconnect();
      }

      this.__nodeObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          var target = mutation.target; // Ensure the mutation target is the currently connected node
          // to ignore async mutations dispatched for removed element.

          var isCurrentNodeMutation = target === _this.node;

          if (mutation.type === 'attributes') {
            // We use attributeFilter to only observe ID mutation,
            // no need to check for attribute name separately.
            if (isCurrentNodeMutation) {
              _this.__updateNodeId(target);
            }
          } else if (isCurrentNodeMutation || target.parentElement === _this.node) {
            // Node text content has changed.
            _this.__notifyChange(_this.node);
          }
        });
      }); // Observe changes to node ID attribute, text content and children.

      this.__nodeObserver.observe(node, {
        attributes: true,
        attributeFilter: ['id'],
        childList: true,
        subtree: true,
        characterData: true
      });
    }
    /**
     * Returns true if a node is an HTML element with children,
     * or is a defined custom element, or has non-empty text.
     *
     * @param {Node} node
     * @return {boolean}
     * @private
     */

  }, {
    key: "__hasContent",
    value: function __hasContent(node) {
      if (!node) {
        return false;
      }

      return node.nodeType === Node.ELEMENT_NODE && (customElements.get(node.localName) || node.children.length > 0) || node.textContent && node.textContent.trim() !== '';
    }
    /**
     * Fire an event to notify the controller host about node changes.
     *
     * @param {Node} node
     * @private
     */

  }, {
    key: "__notifyChange",
    value: function __notifyChange(node) {
      this.dispatchEvent(new CustomEvent('slot-content-changed', {
        detail: {
          hasContent: this.__hasContent(node),
          node: node
        }
      }));
    }
    /**
     * Set default ID on the node in case it is an HTML element.
     *
     * @param {Node} node
     * @private
     */

  }, {
    key: "__updateNodeId",
    value: function __updateNodeId(node) {
      // When in multiple mode, only set ID attribute on the element in default slot.
      var isFirstNode = !this.nodes || node === this.nodes[0];

      if (node.nodeType === Node.ELEMENT_NODE && (!this.multiple || isFirstNode) && !node.id) {
        node.id = this.defaultId;
      }
    }
  }]);

  return SlotChildObserveController;
}(SlotController);